// extracted by mini-css-extract-plugin
export default {"container":"LamellaArea_container__qhxoE","meters":"LamellaArea_meters__lMgwS","scopeWrapper":"LamellaArea_scopeWrapper__ICKjt"};